module.exports = __webpack_public_path__ + "img/page2img1.8ac58893.png";